import MarqueeRow from "@/components/MarqueeRow";
import { proxied } from "@/lib/api";

const MediaFeatured = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <section className="bg-white py-10 md:py-14 border-y border-[rgba(45,40,37,0.08)]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-6 text-center">
        <div className="text-[#8B2323] text-[10px] md:text-xs tracking-[0.5em] uppercase">
          Featured &amp; Recognised
        </div>
      </div>
      <MarqueeRow direction="left" speed={25} gap={56} noPause>
        {items.map((m) => (
          <a
            key={m.id}
            href={m.link || "#"}
            target={m.link ? "_blank" : undefined}
            rel="noopener noreferrer"
            data-cursor="button"
            className="flex-shrink-0 h-16 md:h-20 px-6 flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity"
          >
            <img
              src={proxied(m.logo)}
              alt={m.name}
              className="max-h-full max-w-[160px] object-contain"
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.insertAdjacentHTML("afterend", `<span class='font-serif text-lg text-[#5C544F]'>${m.name}</span>`);
              }}
            />
          </a>
        ))}
      </MarqueeRow>
    </section>
  );
};

export default MediaFeatured;
